import { render, staticRenderFns } from "./ActivityLogItem.vue?vue&type=template&id=27879220&"
import script from "./ActivityLogItem.vue?vue&type=script&lang=js&"
export * from "./ActivityLogItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports